import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { cn } from 'shadcn-ui';
import { SeparatorLayoutProps } from '../types';

import styles from './Separator.module.scss';

const MARGIN_CLASSES = {
  small: 'my-[1rem]',
  medium: 'my-5',
  big: 'my-[2.5rem]',
} as const;

function LegacySeparatorLayoutWeb(props: SeparatorLayoutProps) {
  const marginSize = props.marginSize || 'medium';

  const classNames = [
    styles.separator,
    `margin-${marginSize}`,
    props.isBold ? styles.bold : '',
    props.className || '',
  ];

  return (
    <div className={classNames.join(' ')}>&nbsp;</div>
  );
}

function ShadcnSeparatorLayoutWeb(props: SeparatorLayoutProps) {
  const marginSize = props.marginSize || 'medium';

  return (
    <div
      className={cn(
        'w-full h-px bg-gray-200',
        props.isBold && 'h-[2px]',
        MARGIN_CLASSES[marginSize],
        props.className,
      )}
    >&nbsp;</div>
  );
}

export default function SeparatorLayoutWeb(props: SeparatorLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSeparatorLayoutWeb {...props} />;
  } else {
    return <LegacySeparatorLayoutWeb {...props} />;
  }
}
